export default __webpack_public_path__ + "static/media/uefa24-prediction-id.60db66c7.webp";